export default function getMainColor() {
    return getCssVariableColor('--c-main');
}

export function getCssVariableColor(name: string) {
    const r = document.querySelector(':root') as any; // any car notre version de typescript n'as pas les dernière déclaration lié aux variable CSS.
    const rs = getComputedStyle(r);
    return rs.getPropertyValue(name);
}